import React from 'react';
import { bool, func, string } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { Modal, PrimaryButton, SecondaryButton } from '../../components';

import css from './TeliaEmailPromptModal.module.css';

/**
 * TeliaEmailPromptModal is a one-time modal that prompts Telia-authenticated users
 * to update their auto-generated email address so they can receive notifications.
 * 
 * This modal should only be shown once per user (tracked via privateData.teliaEmailPromptShown)
 */
const TeliaEmailPromptModal = props => {
  const {
    id,
    className,
    rootClassName,
    isOpen,
    onManageDisableScrolling,
    onClose,
    onNavigateToSettings,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      className={classes}
    >
      <div className={css.content}>
        <div className={css.iconWrapper}>
          <span className={css.icon}>✉️</span>
        </div>
        
        <h2 className={css.heading}>
          <FormattedMessage
            id="TeliaEmailPromptModal.title"
            defaultMessage="Tervetuloa! / Welcome!"
          />
        </h2>
        
        <p className={css.message}>
          <FormattedMessage
            id="TeliaEmailPromptModal.message"
            defaultMessage="Voit nyt hallinnoida yritysprofiiliasi. Päivitä sähköpostiosoitteesi, jotta saat ilmoitukset asiakkaiden kyselyistä."
          />
        </p>
        
        <p className={css.submessage}>
          <FormattedMessage
            id="TeliaEmailPromptModal.submessage"
            defaultMessage="You can now manage your company profile. Update your email address to receive notifications about customer inquiries."
          />
        </p>
        
        <div className={css.buttons}>
          <PrimaryButton
            onClick={onNavigateToSettings}
            className={css.updateButton}
          >
            <FormattedMessage
              id="TeliaEmailPromptModal.updateEmailButton"
              defaultMessage="Päivitä sähköposti"
            />
          </PrimaryButton>
          
          <SecondaryButton
            onClick={onClose}
            className={css.skipButton}
          >
            <FormattedMessage
              id="TeliaEmailPromptModal.skipButton"
              defaultMessage="Ohita toistaiseksi"
            />
          </SecondaryButton>
        </div>
      </div>
    </Modal>
  );
};

TeliaEmailPromptModal.defaultProps = {
  className: null,
  rootClassName: null,
};

TeliaEmailPromptModal.propTypes = {
  id: string.isRequired,
  className: string,
  rootClassName: string,
  isOpen: bool.isRequired,
  onManageDisableScrolling: func.isRequired,
  onClose: func.isRequired,
  onNavigateToSettings: func.isRequired,
};

export default TeliaEmailPromptModal;
